import { ErrorToast, SuccessToast } from "../components/toastify";
import HandleLogout from "../hooks/handleLogout";
import { AxiosPostMethod } from "./customAxios";

const ResendOtp = async () => {
  const successRes = await await AxiosPostMethod("resend/otp", {});
  console.log("successRes", successRes);
  if (successRes.status === 200) {
    SuccessToast("OTP sent successfully");
    return true;
  } else {
    if (successRes?.status === 401) HandleLogout();
    ErrorToast("Can't send OTP");
    return null;
  }
};
export default ResendOtp;
